import React, {useContext, useCallback} from 'react'
import {FrameHeader, CheckMarkCard} from 'js/studios/shared/flows'
import {FlowFramesCtx} from 'js/studios/shared/unredux/contexts/flow'
import {KeyValueCtx} from 'js/studios/shared/unredux/contexts/key_value'

function ChooseCategoryFrame({field, title, description, cards}) {
  const
    {gotoNextFrame} = useContext(FlowFramesCtx),
    {setKey} = useContext(KeyValueCtx),
    onSelect = useCallback(ev => {
      ev.preventDefault()
      setKey(field, ev.target.value)
      gotoNextFrame()
    }, [field, gotoNextFrame, setKey])

  return <div className="flow-frame anim--fade-in">
    <div className="flow-frame__body">
      <FrameHeader>{title}</FrameHeader>
      <p className="txt--center mb--lg">{description}</p>
      <div className="check-mark-cards-list check-mark-cards-list--3col">
        {cards.map(card => <CheckMarkCard
          key={card.name}
          imgs={[card.img]}
          value={card.name}
          description={card.label}
          checked={false}
          disabled={false}
          onClick={onSelect}
        />)}
      </div>
    </div>
  </div>
}

const CATEGORY_TOP_CHOICES = [
  {
    name: "engagement",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/engagement-ring.jpg`,
    label: "Engagement Ring"
  },
  {
    name: "other",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/other.jpg`,
    label: "Other Jewelry"
  },
]

export function ChooseCategoryTopFrame() {
  return <ChooseCategoryFrame
    title="First, what are we making?"
    description="Seeking the perfect engagement ring, or another type of jewelry?"
    field="categoryTop"
    cards={CATEGORY_TOP_CHOICES}
    />
}

const CATEGORY_SECONDARY_CHOICES = [
  {
    name: "signet_ring",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/signet-ring.jpg`,
    label: "Signet Ring"
  },
  {
    name: "mens_wedding_band",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/mens-band.jpg`,
    label: "Men's Wedding Band"
  },
  {
    name: "womens_wedding_band",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/womens-band.jpg`,
    label: "Women's Wedding Band"
  },
  {
    name: "cocktail_ring",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/cocktail-ring.jpg`,
    label: "Cocktail / Gemstone Ring"
  },
  {
    name: "wedding_band_set",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/band-set.jpg`,
    label: "Wedding Band Set"
  },
  {
    name: "class_ring",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/class-ring.jpg`,
    label: "Class Ring"
  },
  {
    name: "necklace",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/necklace.jpg`,
    label: "Necklace"
  },
  {
    name: "cufflinks",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/cufflinks.jpg`,
    label: "Cufflinks"
  },
  {
    name: "earrings",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/earrings.jpg`,
    label: "Earrings"
  },
  {
    name: "other_ring",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/other-ring.jpg`,
    label: "Other Ring"
  },
  {
    name: "other",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/categories/other2.jpg`,
    label: "Other"
  }
]

export function ChooseCategorySecondaryFrame() {
  return <ChooseCategoryFrame
    title="Choose a type of jewelry."
    description="We offer many types of rings, in addition to other kinds of jewelry."
    field="categorySecondary"
    cards={CATEGORY_SECONDARY_CHOICES}
    />
}
